import _get from 'lodash/get';
export default function(data) {
  let type = _get(data, '__typename');
  const typesMapping = {
    application: 'apps',
    activity: 'articles',
    book: 'books',
    onlineprogram: 'programs',
    organization: 'organizations',
    person: 'people',
    podcast: 'podcasts',
    video: 'videos',
    blog: 'blogs',
    source: 'source',
    list: 'lists',
  };
  const isBlog = _get(data, 'blog', false);
  type = isBlog ? 'blogs' : type;
  return typesMapping[type.toLowerCase()] || type.toLowerCase();
}
